import React, { createContext, useContext, useState } from 'react';
import { cn } from './cn';

const TooltipContext = createContext({ open: false });

function TooltipProvider({ children }) {
  return children;
}

function Tooltip({ children }) {
  const [open, setOpen] = useState(false);

  return (
    <TooltipContext.Provider value={{ open }}>
      <span
        className="relative inline-flex items-center"
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
      >
        {children}
      </span>
    </TooltipContext.Provider>
  );
}

const TooltipTrigger = React.forwardRef(
  ({ children, asChild, ...props }, ref) => {
    if (asChild && React.isValidElement(children)) {
      return React.cloneElement(children, {
        ...props,
        ref,
      });
    }

    return (
      <span ref={ref} tabIndex={0} {...props}>
        {children}
      </span>
    );
  }
);
TooltipTrigger.displayName = 'TooltipTrigger';

const TooltipContent = React.forwardRef(({ className, sideOffset = 8, children, ...props }, ref) => {
  const { open } = useContext(TooltipContext);

  if (!open) return null;

  return (
    <div
      ref={ref}
      className={cn(
        'absolute left-1/2 top-0 z-50 -translate-x-1/2 -translate-y-full overflow-hidden rounded-md border border-succession-border bg-succession-bg-primary px-3 py-1.5 text-sm text-succession-text-primary shadow-succession whitespace-nowrap pointer-events-none',
        className
      )}
      style={{ marginTop: `-${sideOffset}px` }}
      role="tooltip"
      {...props}
    >
      {children}
    </div>
  );
});
TooltipContent.displayName = 'TooltipContent';

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
